module.exports = {
	"en": {
		"hqm": {
			"support-button": "Get support",
			"support-page": {
				"create-ticket": {
					"title": "Get support",
					"instructions": "Submit a request below and we will get back to you.",
					"fields": {
						"mid": {
							"label": "Select store",
							"validation": "Store required"
						},
						"topic": {
							"question": "What is your question related to?",
							"label": "Select a topic",
							"validation": "Topic required",
							"options": {
								"orders": "Orders",
								"settlements": "Settlements",
								"agreements": "Agreements",
								"technical_issues": "Technical issues",
								"others": "Others"
							}
						},
						"subject": {
							"label": "Subject",
							"validation": "Subject required"
						},
						"description": {
							"label": "Message",
							"validation": "Description required"
						},
						"attachment": {
							"label": "Add attachments",
							"button": "Upload",
							"info": "Adding screenshots will help us solve the issue faster.",
							"supportedFileTypes": "Supported file types: .png, .jpg, .pdf",
							"error": "Total files size may not exceed 15 MB"
						}
					},
					"submit": "Submit request",
					"service-unavailable-error": "Oops! Something went wrong, try again in a few minutes. If this continues, please {link} for help.",
					"generic-error": "We couldn't process your request. Our systems aren't talking to each other right now. Try refreshing, or come back later. If this continues, please {link} for help.",
					"contact-page-link": "contact us"
				},
				"view-ticket": {
					"title": "All done!",
					"details": "We've got your request and we'll get you an answer shortly. Here are your details:",
					"ticket": "Request #{ticketId}",
					"email": "Email: {email}",
					"status": "You can track the status in our Support page.",
					"track": "Track status"
				}
			},
			"popup": {
				"yes": "Yes",
				"no": "No",
				"somethingElse": "I need help with something else"
			},
			"header": {
				"homeLink": "Reset"
			},
			"home": {
				"greeting": "Hello {givenName}! How can we help you?",
				"topics": "What do you need help with?"
			},
			"topics": {
				"expandButton": "More"
			},
			"moreHelp": {
				"relatedArticlesParagraph": "We're sorry that this didn't help. Maybe some of these articles might help you?",
				"stillQuestionsTitle": "Still have Questions?",
				"stillQuestionsParagraph": "You can also contact us directly.",
				"contactButton": "Contact us"
			},
			"feedback": {
				"title": "Was this helpful?",
				"optionYes": "Yes, this was helpful",
				"optionNo": "No, I need more help",
				"positiveFeedback": "Thank you for the positive feedback, this helps us a lot to provide you with more relevant articles in the future."
			},
			"freeTextFeedback": {
				"title": "Help us improve",
				"placeholder": "Why did you not find this content useful?",
				"submitButton": "Send",
				"feedbackMessage": "Thank you for your feedback, this helps us a lot to provide you with more relevant articles in the future."
			},
			"relatedContent": {
				"title": "Related content"
			},
			"search": {
				"buttonLabel": "Search",
				"input": "Search for articles ...",
				"loading": "Loading ...",
				"results": {
					"contact": "Can't find the help you need?",
					"empty": "Sorry, no results were found for your query. Try searching for a different term.",
					"singleTopicFound": "We've found 1 topic",
					"multipleTopicsFound": "We've found {count} topics",
					"singleArticleFound": "We've found 1 article",
					"multipleArticlesFound": "We've found {count} articles"
				}
			},
			"contact": {
				"title": "Contact us",
				"channelsIntro": "Reach out to us so that we can help you.",
				"businessDetailsTitle": "Your business details",
				"businessDetailsName": "Business Name",
				"businessDetailsEmail": "Email",
				"businessDetailsMid": "Merchant ID",
				"phone": {
					"title": "Call us",
					"paragraph": "You can give us a call during business hours on weekdays. If you're located in Sweden or the United Kingdom, you can also call us on the weekend between 10am-4pm."
				},
				"chat": {
					"title": "Chat with us",
					"paragraph": "The quickest and easiest way to reach Support. Our chat is currently open.",
					"button": "Open Chat"
				},
				"email": {
					"title": "Email us",
					"paragraph": "Shoot us an email and we will get back to you as soon as we can."
				}
			},
			"errorBoundary": {
				"title": "Something went wrong",
				"message": "We are very sorry but there was an error. You can click the button below to reset and close this sidebar.",
				"resetButton": "Reset",
				"errorId": "Error ID: {errorId}"
			},
			"tour": {
				"prev": "Previous",
				"next": "Next",
				"done": "Done"
			},
			"notAvailableMobile": {
				"title": "Not Available",
				"buttonBack": "Back",
				"paragraph": "This content is not available on your device. Try opening on a device with a larger screen size such as a desktop computer."
			},
			"shareButton": {
				"title": {
					"article": "Share a deep link to this article",
					"topic": "Share a deep link to this topic",
					"tour": "Share a deep link to this tour"
				},
				"radioItemHome": "Home App",
				"descriptionHome": "Opens help article on Merchant Portal home page",
				"radioItemCurrent": "Current Page",
				"descriptionCurrent": "Opens help article on current page"
			}
		},
		"orientation": {
			"title": "Learn how to ..."
		},
		"core": {
			"alert": {
				"message": "Something went wrong! Please try again.",
				"correlationIdLabel": "Correlation ID:"
			},
			"header": {
				"title": "Merchant Portal"
			},
			"usermenu": {
				"language": "Language",
				"country": "Country",
				"timezone": "Timezone",
				"logout": "Logout",
				"profile": "Profile",
				"changeProfile": "Edit",
				"tooltip": "Your profile"
			},
			"appsmenu": {
				"defaultTooltip": "Your apps",
				"initialTooltip": "Find your apps here.",
				"newAppsTooltip": "We have new apps for you!"
			},
			"helpful-question-mark": {
				"helpLabel": "Help"
			},
			"languages": {
				"da": "Danish",
				"de": "German",
				"en": "English",
				"en_GB": "English (GB)",
				"en_US": "English (US)",
				"es": "Spanish",
				"fi": "Finnish",
				"fr": "French",
				"it": "Italian",
				"nl": "Dutch",
				"no": "Norwegian",
				"sv": "Swedish"
			},
			"countries": {
				"de": "Germany",
				"dk": "Denmark",
				"fi": "Finland",
				"gb": "Great Britain",
				"nl": "Netherlands",
				"no": "Norway",
				"se": "Sweden",
				"us": "United States"
			},
			"selectLanguage": {
				"title": "Select your language",
				"paragraph": "This will be your default language.",
				"submit": "OK"
			},
			"selectCountry": {
				"title": "Select your country",
				"paragraph": "This will be your default country.",
				"submit": "OK"
			},
			"updateProfile": {
				"title": "Update Details",
				"submit": "OK",
				"emailLabel": "E-mail address",
				"firstNameLabel": "First name",
				"lastNameLabel": "Last name",
				"resetPasswordLabel": "Reset password",
				"resetPasswordSuccessLabel": "Password reset email sent",
				"resetPasswordErrorLabel": "Error sending password reset email",
				"error": "Details update failed"
			},
			"footer": {
				"copyright": {
					"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). All rights reserved",
					"oc": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579",
					"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215"
				},
				"terms": "Terms & Conditions"
			},
			"accessDenied": {
				"title": "You need additional access for this page.",
				"message": "Contact your administrator or Klarna with any questions."
			},
			"midSelector": {
				"label": "Store"
			},
			"storeSelector": {
				"label": "Store"
			},
			"storesSelector": {
				"closeText": "Done",
				"closeTextWithSelection": "Apply # selection(s)",
				"deselectAllOptionText": "Clear selection",
				"emptyStateText": "No stores found",
				"label": "Stores",
				"searchFieldLabel": "Search by store",
				"selectAllOptionText": "Select all stores",
				"selectedAllText": "All stores",
				"selectedText": "# stores"
			},
			"pagination": {
				"ofLabel": "of",
				"noResultsLabel": "No results"
			},
			"dateRangePicker": {
				"startLabel": "Start Date",
				"endLabel": "End Date",
				"months": {
					"january": "January",
					"february": "February",
					"march": "March",
					"april": "April",
					"may": "May",
					"june": "June",
					"july": "July",
					"august": "August",
					"september": "September",
					"october": "October",
					"november": "November",
					"december": "December"
				},
				"weekDaysShort": {
					"monday": "M",
					"tuesday": "T",
					"wednesday": "W",
					"thursday": "T",
					"friday": "F",
					"saturday": "S",
					"sunday": "S"
				}
			},
			"appIcon": {
				"newLabel": "NEW"
			},
			"appCategory": {
				"dayToDay": "For your day-to-day",
				"nko": "Klarna Online",
				"tools": "Tools",
				"preferences": "Preferences"
			},
			"apps": {
				"home-fe": {
					"title": "Home"
				},
				"nko-app": {
					"title": "Klarna Online Apps"
				},
				"orders-fe": {
					"title": "Orders",
					"description": "Search and manage your orders from Klarna.",
					"nkoLinkText": "Access older orders"
				},
				"nko-orders": {
					"title": "Orders (KO)",
					"description": "Search and manage your orders made through Klarna Online."
				},
				"settlements-fe": {
					"title": "Settlements",
					"description": "Get reports tailored to your business needs.",
					"nkoLinkText": "Access older reports"
				},
				"nko-settlements": {
					"title": "Settlements (KO)",
					"description": "Find reports on orders and payouts from Klarna Online."
				},
				"logs-app-fe": {
					"title": "Logs",
					"description": "Search API logs to troubleshoot integration problems."
				},
				"users-fe": {
					"title": "Users",
					"description": "Invite new users and manage existing users in the Portal."
				},
				"settings-fe": {
					"title": "Settings",
					"description": "Request your Klarna API credentials and manage store settings."
				},
				"nko-settings": {
					"title": "Settings (KO)",
					"description": "Manage your store settings, reports and contact details."
				},
				"seller-fe": {
					"title": "Point of Sale",
					"description": "Create new orders with the Klarna in-store solution."
				},
				"products-fe": {
					"title": "Products",
					"description": "Guides you on your way to get the most out of Klarna."
				},
				"upstream-fe": {
					"title": "On-site messaging",
					"description": "Sell more with tailored and personalized financing offers."
				},
				"lending-fe": {
					"title": "Merchant Lending",
					"description": "Business financing, made simple."
				},
				"branding-fe": {
					"title": "Branding",
					"description": "Take control over how your brand is presented within Klarna."
				},
				"disputes-fe": {
					"title": "Disputes",
					"description": "Handle your disputes."
				},
				"logistics-fe": {
					"title": "Logistics",
					"description": "Manage all your logistics in one place."
				},
				"ob-transactions-fe": {
					"title": "Transactions",
					"description": "Open Banking Transactions"
				},
				"developers": {
					"title": "Developers"
				},
				"product-upgrade-fe": {
					"title": "Product upgrade"
				},
				"marketing": {
					"title": "Marketing",
					"description": "Grab marketing assets here to grow your business."
				},
				"business-card-fe": {
					"title": "Business Card",
					"description": "Coming soon"
				},
				"support": {
					"title": "Support",
					"description": "Check and manage your support requests."
				}
			},
			"ui": {
				"buttons": {
					"backButton": "Back"
				}
			},
			"errorBoundary": {
				"contact": "Please try refreshing the page. {br}If the error persists, contact <supportLink>Merchant Support</supportLink> providing the id {errorId}",
				"errorDescription": "Error ID - {errorId}",
				"reloadButton": "Refresh",
				"title": "Unfortunately there's been an error"
			},
			"maintenance": {
				"pageTitle": "Maintenance",
				"title": "The Merchant Portal is currently undergoing scheduled maintenance",
				"summary": "We’ll be back soon",
				"scheduledSummary": "We’ll be back at {until}"
			}
		},
		"blackFriday": {
			"v1": {
				"title": "Black Friday",
				"intro": "One of the most important retail days is almost upon us. During Black Friday, we’ll be here to deliver near-time statistics of your sales. In the meantime, let’s prepare for success!",
				"countdown": "Starting in #dd #hh #mm #ss…",
				"box1": {
					"title": "3.5x more spending*",
					"text": "Last year, Klarna shoppers* spent, on average, 3.5x more on Black Friday than they did on any other day of the year.",
					"footnote": "*Average across all Klarna merchant categories and regions."
				},
				"box2": {
					"title": "2.5x sales volume*",
					"text": "Last year, Klarna merchants generated 2.5x more sales volume on Black Friday than any other day of the year.",
					"footnote": "*Average across all Klarna merchant categories and regions."
				},
				"sectionTitle": "Let’s grow your Black Friday sales",
				"marketing": {
					"title": "Market your business before and on Black Friday",
					"text": "Drive more shoppers to your store during the Black Friday shopping season with these free-to-use resources for social media and email campaigns."
				},
				"branding": {
					"title": "Get seen in the Klarna app",
					"text": "12 million shoppers use the Klarna app every month. Make sure you shine in the app this Black Friday by adding and updating your brand information here in the Merchant Portal."
				},
				"cta": "Get started",
				"close": "Close"
			},
			"v2": {
				"title": "Black week",
				"orderVolume": "Sales volume",
				"orderCountTitle": "Number of orders",
				"orderCount": "{count} orders",
				"box": {
					"title": "Want to increase conversion further?",
					"subtitle1": "On-site Messaging",
					"subtitle2": "Promotional messaging that educates.",
					"text": "Our On-site Messaging tool helps boost your sales and average order values with promotional messaging. Let shoppers know what their payment options are as soon as they come to your site, and throughout their shopping journey.",
					"cta": "Get started"
				},
				"selector": {
					"done": "Done",
					"applySelection": "Apply # selection(s)",
					"selectAll": "Select all",
					"allOptions": "All options selected",
					"someOptions": "# options selected",
					"storeMultiSelectLabel": "Choose # stores",
					"allStores": "All stores"
				},
				"currencyLabel": "Choose currency",
				"storeLabel": "Choose store"
			},
			"v3": {
				"title": "Black Friday week",
				"text": "These are your sales from one of the most important sales week of the year.",
				"summaryTitle": "Summary",
				"orderVolume": "Total volume",
				"orderCount": "Total orders",
				"summaryRange": "23-30 November",
				"comparisonLastWeek": "compared to the same day, last week",
				"tabs": {
					"monday": "Monday",
					"tuesday": "Tuesday",
					"wednesday": "Wednesday",
					"thursday": "Thursday",
					"blackFriday": "Black Friday",
					"saturday": "Saturday",
					"sunday": "Sunday",
					"cyberMonday": "Cyber Monday"
				}
			}
		}
	}
};